import type { ShapeData } from '@/lib/shapes/types/shape-data'
import { buildShapePhotoFill } from '@/lib/photos/fill-shape-with-photo'
import { buildPlacedFillShape } from '@/lib/photos/build-placed-fill-shape'
import type { BuildPlacedPhotoShapeInput } from './types/build-placed-photo-shape-input'

/**
 * A photo dropped directly onto the canvas (not onto an existing shape) creates a real
 * borderless rectangle sized to the photo, with the photo as its `photoFill` — the same
 * mechanism as dropping a photo into a hand-drawn shape (`fill-shape-with-photo.ts`), rather
 * than a distinct "image element" (kindId 4). See `buildPlacedFillShape` for the geometry and the
 * wire-format rationale (Phase 3 §7 "Standalone Image Wire Format").
 */
export function buildPlacedPhotoShape({ photo, ...input }: BuildPlacedPhotoShapeInput): ShapeData {
  return buildPlacedFillShape({
    ...input,
    buildFill: (naturalSize) => buildShapePhotoFill(photo, naturalSize),
  })
}
